var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2551_7007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 2.82593H7C4.23858 2.82593 2 5.0645 2 7.82593V17.8259C2 20.5874 4.23858 22.8259 7 22.8259H17C19.7614 22.8259 22 20.5874 22 17.8259V7.82593C22 5.0645 19.7614 2.82593 17 2.82593Z",
    stroke: "#011563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 12.196C16.1231 13.0282 15.981 13.8782 15.5935 14.625C15.206 15.3718 14.5929 15.9774 13.8413 16.3557C13.0898 16.7339 12.2382 16.8656 11.4075 16.7319C10.5768 16.5983 9.80947 16.2061 9.21455 15.6111C8.61962 15.0162 8.22744 14.2489 8.09377 13.4182C7.96011 12.5875 8.09177 11.7359 8.47003 10.9844C8.84829 10.2328 9.45389 9.61973 10.2007 9.23223C10.9475 8.84473 11.7975 8.70257 12.6297 8.82599C13.4786 8.95187 14.2646 9.34745 14.8714 9.95429C15.4782 10.5611 15.8738 11.3471 15.9997 12.196Z",
    stroke: "#011563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2551_7007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.825928)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.cd9732556a31f9fce250f224e0ab21d7.svg";
export { ForwardRef as ReactComponent };